// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__23VAP","header":"ClearentDisclaimer_header__RFLRs","inner":"ClearentDisclaimer_inner___IvGd"};